<script setup lang="ts">
import animateElementsOnScroll from "@/js/intersection-observer.v2.js";
import glowImg from "@/assets/images/upgraded/glow.svg";

onMounted(() => {
	animateElementsOnScroll(
		"#skills-competence-test",
		"slideFromBot 1s 0s forwards",
		".title, .skills-competence-test-container, .cog-cognito",
	);

	const script = document.createElement("script");
	script.src = "https://www.cognitoforms.com/f/iframe.js";
	script.async = true;
	document.body.appendChild(script);
});
</script>

<template>
	<div id="skills-competence-test">
		<div class="skills-competence-test-inner-wrapper">
			<inline-svg class="glow-img" :src="glowImg"></inline-svg>
			<h1 class="title">Sales and Entrepreneurial Skills Competence Test</h1>
			<div class="skills-competence-test-container">
				<iframe
					src="https://www.cognitoforms.com/f/YNA3aNVjv0Kf79LdM7RWRA/29"
					allow="payment"
					style="border: 0; width: 100%"
					height="1169"
				></iframe>
			</div>
		</div>
	</div>
</template>

<style lang="scss" scoped>
#skills-competence-test {
	padding: 15vh 25px 5vh;
	min-height: 100vh;
	max-width: 1500px;
	margin: 0 auto;

	.skills-competence-test-inner-wrapper {
		position: relative;

		.glow-img {
			position: absolute;
			margin: 0 auto;
			width: 100%;
			max-width: 100%;
			top: 0;
			left: 0;
		}

		.title {
			text-align: center;
			font-style: normal;
			font-weight: 600;
			font-size: 32px;
			line-height: 40px;
			margin-bottom: 50px;
		}
	}
}

@media screen and (width >=768px) {
	#skills-competence-test {
		padding: 300px 25px 5vh;

		.skills-competence-test-inner-wrapper {
			.title {
				font-size: 54px;
				margin-bottom: 100px;
			}
		}
	}
}
</style>
